import { DefaultImageProps } from './types/index';
import { WEBSHOP_BACKGROUD_GRADIENT_URL } from './urls';

export const WebshopBackgroudGradient = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={WEBSHOP_BACKGROUD_GRADIENT_URL}
    alt="background-gradient"
    {...props}
  />
);
